import { Component, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-debounced-search-field',
  templateUrl: './debounced-search-field.component.html',
  styleUrls: ['./debounced-search-field.component.css']
})
export class DebouncedSearchFieldComponent {

 
  searchChangeObserver: any;

  @Output() public SearchClicked = new EventEmitter<any>();

  constructor() { }

  onSearchChange(searchValue: any) {
    searchValue = searchValue.target.value.toLowerCase();

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500), distinctUntilChanged()) 
        // wait 800ms after the last event before emitting last event 
        // only emit if value is different from previous value
        .subscribe(txt => {
          this.SearchClicked.emit(txt);
        });
    }

    this.searchChangeObserver.next(searchValue);
  } 

}
